module.exports = __webpack_public_path__ + "media/images/categories/icon_cat20-8e9e20983e80f2fb6e30a08731e557ed.svg";